// extracted by mini-css-extract-plugin
export default {"inert":"_459a6a78"};